import { Dispatch } from "redux"
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getCompanias = () => async (dispatch: Dispatch) => {
    const { data, status } = await Axios.get('/api/compania/getall/', {
        headers: { auth: localStorage.getItem('jwt') }
    })
    if (status === 200) {
        dispatch({
            type: 'COMPANIA_GETALL_SUCCESS',
            payload: data
        })
    }
}

export const importCompaniasFromEbroker = () => async (dispatch: Dispatch) => {
    dispatch({
        type: 'COMPANIAS_LOADING'
    })
    try {
        const { data, status} = await Axios.get('/api/compania/getallebroker/',  {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'COMPANIAS_IMPORT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'COMPANIAS_NOT_LOADING'
        })
    }
}